const constants = {
    ACCORDION_CLASS: "login__accordion",
    COLLAPSE_CLASS: "login__accordion__collapse",
    OPEN_CLASS: "open"
};

const handleLinkClicked = ({ currentTarget }) => {
    const collapse = currentTarget.closest(`.${constants.COLLAPSE_CLASS}`);
    
    collapse.classList.toggle(constants.OPEN_CLASS);
};

const init = () => {
    const accordionTitles = document.querySelectorAll(`.${constants.ACCORDION_CLASS} .${constants.COLLAPSE_CLASS} h3`);
    
    for(let title of accordionTitles) {
        title.addEventListener("click", handleLinkClicked);
    }
};

document.addEventListener("DOMContentLoaded", init);